/* Sophies Label - Pre-Black Friday countdown. Counts to a fixed moment and then removes the sale UI. */
(function () {
  'use strict';
  if (window.__slBfSale) return;
  window.__slBfSale = true;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function tick() {
    var timers = document.querySelectorAll('[data-sl-bf-timer]');
    var ended = false;
    [].forEach.call(timers, function (t) {
      var left = Math.floor((new Date(t.getAttribute('data-end')).getTime() - Date.now()) / 1000);
      if (isNaN(left)) return;
      if (left <= 0) { ended = true; return; }
      var values = {
        d: Math.floor(left / 86400),
        h: Math.floor(left % 86400 / 3600),
        m: Math.floor(left % 3600 / 60),
        s: left % 60
      };
      Object.keys(values).forEach(function (u) {
        var el = t.querySelector('[data-unit="' + u + '"]');
        var text = pad(values[u]);
        if (el && el.textContent !== text) el.textContent = text;
      });
    });
    if (ended) {
      [].forEach.call(document.querySelectorAll('[data-sl-bf-hide-on-end]'), function (el) { el.style.display = 'none'; });
    }
  }

  function restoreBundles() {
    [].forEach.call(document.querySelectorAll('[data-sl-bf-bundle]'), function (el) {
      var end = new Date(el.getAttribute('data-end')).getTime();
      if (Date.now() < end) return;
      el.classList.remove('sl-bf-bundle');
      [].forEach.call(el.querySelectorAll('[data-sl-bf-hide-on-end]'), function (t) { t.style.display = 'none'; });
    });
  }

  function start() { tick(); restoreBundles(); setInterval(function () { tick(); restoreBundles(); }, 1000); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
